import { ArrowRight, BookOpen } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Card, CardContent } from "@/components/ui/card";
import { DOCS_PATH } from "@/lib/docs-pages";
import { cn } from "@/lib/utils";

/**
 * For people who are not admins: the way to the docs, where connecting Claude,
 * what to ask and what the connector keeps are explained.
 */
export function DocsPointer({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <Card className={cn("flex flex-col", className)}>
      <CardContent className="flex flex-1 gap-4 pt-6 max-sm:px-4">
        {/* De Ceuster's icon style: a white line icon in a blue circle. */}
        <span
          aria-hidden="true"
          className="bg-primary text-primary-foreground flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
        >
          <BookOpen className="h-5 w-5" strokeWidth={1.75} />
        </span>
        <div className="min-w-0">
          <h2 className="font-heading text-primary text-lg font-bold">{t("home.docsTitle")}</h2>
          <p className="text-muted mt-1 text-sm">{t("home.docsBody")}</p>
          <Link
            to={DOCS_PATH}
            className="text-accent tap-target mt-4 inline-flex items-center gap-1 text-sm font-medium hover:underline pointer-coarse:relative"
          >
            {t("home.docsLink")}
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}
